export const Notifications = (notification) => {
    let notificationText = notification;
    if (typeof notificationText !== 'undefined') {
        notificationText.map(chkNotificationText => {
            if (chkNotificationText.text === undefined) {
                notificationText = '';
            }
        });
    }
    // if this is not an empty string, notification component displays that a notification is available
    return notificationText ?? '';
}

